import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc2b7dae")

_pushScopeId("data-v-fc2b7dae")
const _hoisted_1 = { class: "info-item-bottom" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_3 = { class: "display-flex " }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "width5px" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "info-title-bottom" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.OrderBillingInformation,
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        "label-position": _ctx.$formLabelPosition,
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "form"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelBillBillingTitle,
            prop: "BillingTitle"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.BillingTitle,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.BillingTitle = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelBillATTN,
            prop: "Contactor"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Contactor,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Contactor = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("p", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.TabelCommunitiesAddress), 1)
          ]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                filter: "",
                modelValue: _ctx.formData.Country,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Country = $event)),
                width: "100%",
                placeholder: _ctx.$wordList.ProperAllTextCountryRegion
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              class: "flex2",
              prop: "City"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.City,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.City = $event)),
                  placeholder: _ctx.$wordList.TabelCommunitiesCity
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_el_form_item, {
              class: [_ctx.postClass, "flex1"],
              prop: "Postcode"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Postcode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.Postcode = $event)),
                  placeholder: _ctx.$wordList.TabelCommunitiesPostal,
                  onBlur: _ctx.postcodeBlur
                }, null, 8, ["modelValue", "placeholder", "onBlur"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createVNode(_component_el_form_item, {
            prop: "Street",
            style: { marginBottom: _ctx.limitBottom?'5px':'22px'}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Street,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.Street = $event)),
                onBlur: _ctx.streetBlur,
                placeholder: _ctx.$wordList.TabelCommunitiesStreet
              }, null, 8, ["modelValue", "onBlur", "placeholder"])
            ]),
            _: 1
          }, 8, ["style"]),
          _hoisted_5,
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelBillTEL,
            prop: "TelePhone"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.TelePhone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.TelePhone = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelBillFax
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Fax,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.Fax = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageEmail,
            prop: "Email"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Email,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.Email = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["label-position", "rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
})